import PropTypes from 'prop-types';

const TAG_TYPE = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});

export const TAG_INPUT_PROP_TYPES = {
  id: PropTypes.string,
  tags: PropTypes.arrayOf(TAG_TYPE),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  isTagTextClipped: PropTypes.bool,
  shouldCreateTagOnPaste: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onCreateOption: PropTypes.func,
};
